import { useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Row,
  Spinner,
  Modal,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  resetExcelUploadError,
  saveExcelUpload,
} from "../../redux/evaluacion_desempenio/cargaArchivosExcel/actions";

function ExcelFile(props) {
  const dispatch = useDispatch();

  // states
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);

  // variables redux
  const { loading, excelUploadError, excelUploadProblems } = useSelector(
    (store) => store.excelUpload
  );
  //schema
  const schema = Yup.object().shape({
    archivos: Yup.string().required("**Campo requerido"),
  });

  // submit function

  const onSubmit = (req) => {
    // debugger;
    // console.log("item: ", props.item);
    const _req = new FormData();
    _req.append("archivos", document.getElementById("archivos").files[0]);
    _req.append(
      "id_evaluacion_competencia",
      parseInt(props.item.listado_evaluaciones.evaluaciones_competencia[0][0])
    );
    dispatch(saveExcelUpload(_req, props.handleClose));
  };
  return (
    <Modal
      show={props.show}
      onHide={props.handleClose}
      //   onShow={viewEvaluators}
    >
      <Formik
        validationSchema={schema}
        onSubmit={onSubmit}
        initialValues={{
          archivos: "",
        }}
      >
        {({
          handleSubmit,
          handleChange,
          setFieldValue,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
        }) => (
          <Form onSubmit={handleSubmit} noValidate validated={validated}>
            <Modal.Header closeButton>
              <Modal.Title className="text-muted">
                Cargar evaluación
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {excelUploadError ? (
                <Alert variant="danger" className="my-4">
                  {excelUploadError}
                </Alert>
              ) : (
                ""
              )}
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  Archivo excel
                </Form.Label>
                <Col sm={9}>
                  <Row>
                    <Col>
                      <Form.File
                        multiple
                        id="archivos"
                        name="archivos"
                        className="col position-relative my-2"
                        // disabled={
                        //   edit &&
                        //   editItem.list_estado[0].nombre_estado.toLowerCase() ===
                        //     "cerrado"
                        // }
                        value={values.archivos}
                        onChange={handleChange}
                        onBlur={handleBlur("archivos")}
                        isValid={touched.archivos && !errors.archivos}
                        isInvalid={touched.archivos && !!errors.archivos}
                      />
                    </Col>
                  </Row>
                  {touched.archivos && errors.archivos && (
                    <Col>
                      <small className="text-danger">{errors.archivos}</small>
                    </Col>
                  )}
                </Col>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="rounded-pill"
                variant="secondary"
                onClick={props.handleClose}
              >
                Cerrar
              </Button>
              <Button
                className="rounded-pill"
                disabled={loading || props.item.estado === false}
                variant="primary"
                type="submit"
              >
                {loading && (
                  <Spinner
                    className="mr-2"
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
                Cargar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export default ExcelFile;
